import { CountryCode } from "libphonenumber-js/types";
import create, { GetState, SetState } from "zustand";
import { GenericObjectType } from "../types/global";
import { SignUpDataType } from "../types/signup.types";

export type SignupStoreType = {
  signUpData?: SignUpDataType;
  setSignUpData: (signUpData?: SignUpDataType) => void;
  signUpInputsErrors?: GenericObjectType;
  setSignUpInputsErrors: (signUpInputsErrors: GenericObjectType) => void;
  contactNumber: string;
  setContactNumber: (contactNumber: string) => void;
  callingCode: string;
  setCallingCode: (callingCode: string) => void;
  countryCode: CountryCode;
  setCountryCode: (countryCode: CountryCode) => void;
  isFormLoading: boolean;
  setIsFormLoading: (isFormLoading: boolean) => void;
  parentOrigin: null | string;
  setParentOrigin: (parentOrigin: string) => void;
  OTPType: string;
  setOTPType: (OTPType: string) => void;
};

export const useSignUpStore = create<SignupStoreType>(
  (set: SetState<SignupStoreType>, get: GetState<SignupStoreType>) => ({
    setSignUpData: (signUpData?: SignUpDataType): void => {
      set((state) => {
        state.signUpData = signUpData;
      });
    },
    signUpInputsErrors: {},
    setSignUpInputsErrors: (signUpInputsErrors: GenericObjectType): void => {
      set((state) => {
        state.signUpInputsErrors = signUpInputsErrors;
      });
    },
    contactNumber: "",
    setContactNumber: (contactNumber: string): void => {
      set((state) => {
        state.contactNumber = contactNumber;
      });
    },
    callingCode: "91",
    setCallingCode: (callingCode: string): void => {
      set((state) => {
        state.callingCode = callingCode;
      });
    },
    countryCode: "IN",
    setCountryCode: (countryCode: CountryCode): void => {
      set((state) => {
        state.countryCode = countryCode;
      });
    },
    isFormLoading: false,
    setIsFormLoading: (isFormLoading: boolean): void => {
      set((state) => {
        state.isFormLoading = isFormLoading;
      });
    },
    parentOrigin: null,
    setParentOrigin: (parentOrigin: string): void => {
      set((state) => {
        state.parentOrigin = parentOrigin;
      });
    },
    OTPType: "",
    setOTPType: (OTPType: string): void => {
      set((state) => {
        state.OTPType = OTPType;
      });
    },
  })
);

export default useSignUpStore;
